<template>
    <div>
        <div>
            <div @click="sing_show" class="gengduo_sing" style="width: 55px; height: 55px; border-radius: 40px; background: #FFF;display: flex;align-items: center;justify-content: center;position: fixed;bottom: 100px;left: 8%;box-shadow: 0 0 2px 2px rgb(0 0 0 / 5%); z-index: 99;">
                <img src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/images/shoer_index.png" style="width: 30px;height: 30px;">
            </div>
        </div>
        <!-- 分享弹出框 -->
        <div v-show="show_data" class="Share_with_s" style="position: fixed; top: 0rem;width: 100%;height: 100%;z-index: 9999;display: none;right: 0;">
            <div class="Share_with_s_sing_back" @click="show_data = false" style="width: 100%;height: 100%;background: rgba(0, 0, 0, 0.4);">
            </div>
            <div class="Share_with_s_sing" style=" width: 350px;height: 783px;background: #FFFFFF;border-radius: 12px;position: absolute;top: 0;right: 0;bottom: 0;left: 0;margin: auto;">
                <div class="Share_with_s_sing_img">
                    <img src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/images/shoer_href_04.png" style="width: 350px; height: 349px;">
                    <div class="Share_with_s_sing_img_bkc" style="background-color: #FFFFFF;position: relative;z-index: 99;padding: 38px 32px;border-radius: 20px;margin: 0 auto;margin-top:-127px;">
                        <h4 style="font-size: 16px;font-weight: bold;color: #202020;">新百易打卡</h4>
                        <img src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/images/shoer_href_02.png" style="width: 30px; height: 20px; margin-top: 19px;">
                        <p class="banna_title" style="padding: 9px 11px;font-size: 14px;font-weight: 500;color: #000000;height: 26px;overflow: hidden;">
                            新百易平台
                        </p>
                        <div class="shower_href_bodys_img" style="display: flex;justify-content: right;">
                            <img src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/images/shoer_href_01.png" style="width: 30px; height: 20px;">
                        </div>
                        <div class="is_buy_box_ewma">
                            <div class="img" style="display: flex;justify-content: center;"><canvas width="100" height="100"></canvas></div>
                            <p style="margin-top: 8px;font-size: 12px;font-weight: 400;text-align: center;" class="shoer_pone">①保存图片到相册</p>
                            <p style="margin-top: 8px;font-size: 12px;font-weight: 400;text-align: center;" class="shoer_pone">②打开微信长按二维码扫码可见</p>
                            <p style="margin-top: 8px;font-size: 12px;font-weight: 400;text-align: center;display: none;" class="shoer_ptwo">长按即可识别二维码</p>
                        </div>
                        <div class="is_buy_box_flex" style="display: flex;justify-content: space-around;padding: 0 34px;margin-top: 10px;">
                            <div class="is_buy_box_flex_item" style="cursor: pointer;" @click="copy">
                                <img src="https://fview.5kjs.com/wap_img/punch_the_clock/img/vip/my_40.png" style="background: none; width: 48px; height: 48px;">
                                <p style="margin-top: 8px; font-size: 12px;font-weight: 400; text-align: center;color: #878787;">
                                    复制链接
                                </p>
                            </div>

                            <div @click="download" class="is_buy_box_flex_item" style="cursor: pointer;">
                                <img src="https://fview.5kjs.com/wap_img/punch_the_clock/img/vip/my_39.png" style="background: none; width: 48px; height: 48px;">
                                <p style="margin-top: 11px;font-size: 12px;font-weight: 500;color: #515151;text-align: center;">下载海报</p>
                            </div>
                        </div>
                    </div>
                    <div  @click="show_data = false" class="Share_with_s_btns"   style="width: 319px; height: 49px;background: #FF595B;display: flex;align-items: center;justify-content: center;border-radius: 40px;font-size: 20px;font-family: PingFang SC;margin: 0 auto;font-weight: bold;margin-top: 44px;color: #FFFFFF;">
                        取消
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var that;
export default {
  data() {
    return {
        show_data: false,
        share_url: '',
    };
  },
  created() {
    that = this
    that.share_url = window.location.href;
    var shaxr_url = window.location.origin
    $.post(shaxr_url + "/getshareurl", {share_url:  that.share_url }, function (result) {
        if (result.code == 200) {
            that.share_url = result.data
            that.outputQRCod(that.share_url, 100, 100);
        }
    });

  },
  methods:{
    sing_show() {
        this.show_data = true
    },
    copy() {
        var input1 = document.createElement("input");   // 直接构建input
        input1.value = that.share_url;  // 设置内容
        document.body.appendChild(input1)
        input1.select();   // 选择实例内容
        document.execCommand("Copy");   // 执行复制
        layer.msg('复制成功')
    },
    download() {
        html2canvas(document.querySelector('.Share_with_s_sing_img'), {
            x: $('.Share_with_s_sing').offset().left + 8,
            y: $('.Share_with_s_sing').offset().top,
            useCORS: true,
            allowTaint: true,
            dpi: window.devicePixelRatio * 2
        }).then(canvas => {
            // console.log(canvas.toDataURL())
            var a = $("<a></a>").attr("href", canvas.toDataURL()).attr("download", "新百易分享.png").appendTo("body");

            a[0].click();
            a.remove();
            layer.msg('下载成功')
        });
    },
    outputQRCod(text, width, height) {
        //先清空
        $(".is_buy_box_ewma .img").empty();
        //中文格式转换
        var str = that.toUtf8(text);
        //生成二维码
        $(".is_buy_box_ewma .img").qrcode({
            render: "canvas",//canvas和table两种渲染方式
            width: width,
            height: height,
            text: str
        });
    },
    toUtf8(str) {
        var out, i, len, c;
        out = "";
        len = str.length;
        for (i = 0; i < len; i++) {
            c = str.charCodeAt(i);
            if ((c >= 0x0001) && (c <= 0x007F)) {
                out += str.charAt(i);
            } else if (c > 0x07FF) {
                out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
                out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
                out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
            } else {
                out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
                out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
            }
        }
        return out;
    }
  }
};
</script>

<style  scoped>
    .Share_with_s_sing_img_bkc h4 {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>